import React, { useState, useEffect } from "react";

export default function Message({ messages }) {
    const [slideIndex, setSlideIndex] = useState(0);
    const [fade, setFade] = useState(false);

    useEffect(() => {
        const interval = setInterval(nextSlide, 5000);
        return () => clearInterval(interval);
    }, [slideIndex]);

    const triggerFade = (callback) => {
        setFade(true);
        setTimeout(() => {
            callback();
            setFade(false);
        }, 500);
    };

    const nextSlide = () => {
        if (messages.length > 0) {
            triggerFade(() =>
                setSlideIndex((prev) => (prev + 1) % messages.length)
            );
        }
    };

    const prevSlide = () => {
        if (messages.length > 0) {
            triggerFade(() =>
                setSlideIndex((prev) => (prev - 1 + messages.length) % messages.length)
            );
        }
    };

    return (
        <>
            <div className="p-4 bg-white shadow">
                <h4 className="mb-2 text-xl font-bold">Pesan dan Kesan</h4>
                {messages && messages.length > 0 ? (
                    <div className="w3-content w3-section" style={{ maxWidth: "500px" }}>
                        <div
                            className={`mb-4 transition-opacity duration-300 ${fade ? "opacity-0" : "opacity-100"
                                }`}
                        >
                            <p className="text-gray-700">
                                {messages[slideIndex].konten_pesan}
                            </p>
                            <hr />
                            <p className="text-sm text-gray-500">
                                {messages[slideIndex].nama_pengirim}{" "}
                                <span className="italic">
                                    ({messages[slideIndex].kelas_pengirim})
                                </span>
                            </p>
                        </div>
                        <div className="flex justify-between">
                            <button
                                className="px-4 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600"
                                onClick={prevSlide}
                            >
                                Prev
                            </button>
                            <button
                                className="px-4 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600"
                                onClick={nextSlide}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                ) : (
                    <p className="text-gray-500">Memuat pesan...</p>
                )}
            </div>
        </>
    );
}
